import React, { useState } from 'react'
import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Typography, Divider, Grid, Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { getNpoDocuments } from '../../../Store/npoProfile/npoProfile';
import { enqueueSnackbar } from 'notistack'
import Loading from '../../../Components/Loader/Loading';
import { Link } from 'react-router-dom';
import { Close } from '@mui/icons-material';

export default function Documents({ orgName, id }) {

  const { data: documents, isPending: documentsLoading } = useQuery({
    queryKey: ['documents', orgName],
    queryFn: () => getNpoDocuments(orgName),
    refetchOnWindowFocus: false,
    enabled: !!orgName
  });

  const email = localStorage.getItem('NpoToken') || localStorage.getItem('dataUserAccessToken');

  const [openPdf, setOpenPdf] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);

  // const handleViewFileClick = (e, base64Data, fileType = 'application/pdf') => {
  //   e.preventDefault();
  //   if (!email) {
  //     enqueueSnackbar('Please register or login to view.', { variant: 'error' });
  //     return;
  //   } else {
  //     try {
  //       // Construct the data URL dynamically based on the file type
  //       const dataUrl = `data:${fileType};base64,${base64Data}`;

  //       // Open the file in a new tab
  //       const newWindow = window.open();
  //       if (newWindow) {
  //         if (fileType.startsWith("image/")) {
  //           // For images, display in an <img> tag
  //           newWindow.document.write(`<img src="${dataUrl}" alt="Base64 Image" />`);
  //         } else if (fileType === "application/pdf") {
  //           // For PDFs, embed the file
  //           newWindow.document.write(`<embed src="${dataUrl}" width="100%" height="100%" type="${fileType}" />`);
  //         } else {
  //           // For other types, provide a download link
  //           newWindow.document.write(`
  //           <p>Click the link below to download the file:</p>
  //           <a href="${dataUrl}" download="file">Download File</a>
  //         `);
  //         }
  //       } else {
  //         console.error("Failed to open new window. Popup blocker may be active.");
  //       }
  //     } catch (error) {
  //       console.error("Error displaying file:", error);
  //     }
  //   }
  // }

  const handleViewFileClick = (e, item) => {
    e.preventDefault();

    if (!email) {
      enqueueSnackbar('Please register or login to view.', { variant: 'error' });
      return;
    } else {
      try {
        if (item?.base64_file) {
          // Convert base64 to Blob
          const byteCharacters = atob(item.base64_file);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          // Create URL for the Blob
          const url = URL.createObjectURL(blob);
          setCurrentPdf({
            url,
            fileName: item.file_name || 'document.pdf'
          });
          setOpenPdf(true);
        }
      } catch (error) {

      }
    }
  };

  const handleClosePdf = () => {
    setOpenPdf(false);
    if (currentPdf?.url) {
      URL.revokeObjectURL(currentPdf.url); // Clean up memory
    }
    setCurrentPdf(null);
  };

  return (
    <>
      <div id={id} >
        <Divider sx={{ color: '#E5E8EB', marginTop: '30px', borderBottomWidth: 3 }} />
        <Box className="w-[50%] max-sm:w-[100%]" sx={{ backgroundColor: '#004878', padding: '10px', marginTop: '30px', borderRadius: '15px', display: 'flex', alignItems: 'center' }}>
          <ParagraphComp text='Audited Financial Statements' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
        </Box>
        {(documents?.documents && documents?.documents?.length > 0) ?
          <>
            {documentsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }} > <Loading /></Box > : <Box sx={{ mt: 3 }}>
              <ParagraphComp text='Audited Accounts' className='text-[#004878] text-2xl mb-3 font-bold' />
              <ParagraphComp text='Registered users can view Audited Financial Statements if provided by the organisation.' className='text-[black] text-xl mb-3 font-bold' />
              <Table aria-label="collapsible table">
                <TableHead sx={{ background: '#EDF2F6' }}>
                  <TableRow>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Financial Year</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Document Type</TableCell>
                    <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(documents?.documents && documents?.documents?.length > 0) ? documents?.documents?.map((item, index) =>
                    <TableRow key={index}>
                      <TableCell sx={{ fontSize: '16px' }} align="left">FY {item?.financial_year || '-'}</TableCell>
                      <TableCell sx={{ fontSize: '16px' }} align="left">{item?.file_type || '-'}</TableCell>
                      <TableCell align="left" sx={{ cursor: 'pointer', color: '#004878', fontSize: '16px' }} onClick={(e) => handleViewFileClick(e, item)}>View </TableCell>
                    </TableRow>) : <Typography variant='h5' align='center'>--------</Typography>}
                </TableBody>
              </Table>
              <p className='text-[black] text-base mb-3 font-semibold mt-3'>
                Legal, financial, policy and other documents may be stored voluntarily by the organisation in its profile. These could be made available with the organisation's consent to subscribed users on specific request, subject to terms & conditions.  For details, <Link to="/contact" className='text-blue-600' > contact us.</Link>
              </p>
            </Box>
            }

            <Dialog
              open={openPdf}
              onClose={handleClosePdf}
              maxWidth="lg"
              fullWidth
              sx={{
                '& .MuiDialog-paper': {
                  height: '90vh'
                }
              }}
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 12px' }}>
                {currentPdf?.fileName}
                <IconButton onClick={handleClosePdf}>
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ p: 0 }}>
                {currentPdf && (
                  <iframe
                    src={currentPdf.url}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  />
                )}
              </DialogContent>
            </Dialog>
          </>
          :
          <>
            < ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
            <p className='text-[black] text-base mb-3 font-semibold mt-3'>
              Legal, financial, policy and other documents may be stored voluntarily by the organisation in its profile. These could be made available with the organisation's consent to subscribed users on specific request, subject to terms & conditions.  For details, <Link to="/contact" className='text-blue-600' > contact us.</Link>
            </p>
          </>
        }
      </div>
    </>
  )
}






// import React, { useState } from 'react'
// import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Typography, Divider, Grid } from '@mui/material'
// import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
// import { useQuery } from '@tanstack/react-query';
// import { getNpoDocuments } from '../../../Store/npoProfile/npoProfile';
// import { enqueueSnackbar } from 'notistack'
// import Loading from '../../../Components/Loader/Loading';
// import { Link } from 'react-router-dom';
// import ModalComp from '../../../Components/ModalComp';
// import ClearIcon from '@mui/icons-material/Clear';

// export default function Documents({ orgName, id }) {
//   const [isOpen, setIsOpen] = useState(false);
//   const [filePreview, setFilePreview] = useState(null);

//   const { data: documents, isPending: documentsLoading } = useQuery({
//     queryKey: ['documents', orgName],
//     queryFn: () => getNpoDocuments(orgName),
//     refetchOnWindowFocus: false,
//     enabled: !!orgName
//   });

//   const email = localStorage.getItem('NpoToken');

//   const handleViewFileClick = (e, base64Data, fileType = 'application/pdf') => {
//     e.preventDefault();
//     if (!email) {
//       enqueueSnackbar('Please register or login to view.', { variant: 'error' });
//       return;
//     } else {
//       try {
//         // Set the file preview data and open the modal
//         setFilePreview({
//           data: base64Data,
//           type: fileType
//         });
//         setIsOpen(true);
//       } catch (error) {
//         console.error("Error preparing file for preview:", error);
//         enqueueSnackbar('Failed to open file', { variant: 'error' });
//       }
//     }
//   }

//   const closeModal = () => {
//     setIsOpen(false);
//     setFilePreview(null);
//   };

//   const isPDF = (base64) => {
//     return base64?.startsWith("JVBERi0") || base64?.startsWith("data:application/pdf;base64,");
//   };

//   return (
//     <>
//       <div id={id}>
//         <Divider sx={{ color: '#E5E8EB', marginTop: '30px', borderBottomWidth: 3 }} />
//         <Box sx={{ backgroundColor: '#004878', padding: '10px', marginTop: '30px', borderRadius: '15px', width: '50%', display: 'flex', alignItems: 'center' }}>
//           <ParagraphComp text='Audited Financial Statements' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
//         </Box>
//         {(documents?.documents && documents?.documents?.length > 0) ?
//           <>
//             {documentsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }} > <Loading /></Box > : <Box sx={{ mt: 3 }}>
//               <ParagraphComp text='Audited Accounts' className='text-[#004878] text-2xl mb-3 font-bold' />
//               <ParagraphComp text='Registered users can view Audited Financial Statements if provided by the organisation.' className='text-[black] text-xl mb-3 font-bold' />
//               <Table aria-label="collapsible table">
//                 <TableHead sx={{ background: '#EDF2F6' }}>
//                   <TableRow>
//                     <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Financial Year</TableCell>
//                     <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Document Type</TableCell>
//                     <TableCell sx={{ color: '#004878', fontWeight: 600, fontSize: '16px' }} align="left">Action</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {(documents?.documents && documents?.documents?.length > 0) ? documents?.documents?.map((item, index) =>
//                     <TableRow key={index}>
//                       <TableCell sx={{ fontSize: '16px' }} align="left">FY {item?.financial_year || '-'}</TableCell>
//                       <TableCell sx={{ fontSize: '16px' }} align="left">{item?.file_type || '-'}</TableCell>
//                       <TableCell align="left" sx={{ cursor: 'pointer', color: '#004878', fontSize: '16px' }} onClick={(e) => handleViewFileClick(e, item?.base64_file, item?.file_type?.toLowerCase() === 'pdf' ? 'application/pdf' : 'image/png')}>View</TableCell>
//                     </TableRow>) : <Typography variant='h5' align='center'>--------</Typography>}
//                 </TableBody>
//               </Table>
//               <p className='text-[black] text-base mb-3 font-semibold mt-3'>
//                 Legal, financial, policy and other documents may be stored voluntarily by the organisation in its profile. These could be made available with the organisation's consent to subscribed users on specific request, subject to terms & conditions.  For details, <Link to="/contact" className='text-blue-600' > contact us.</Link>
//               </p>
//             </Box>
//             }

//             <ModalComp closeModal={closeModal} padding='0px' modalIsOpen={isOpen}>
//               <div className={`${filePreview?.type === 'application/pdf' || isPDF(filePreview?.data) ? 'w-[100%]' : 'max-w-[1200px]'} items-center flex justify-center min-h-[200px] max-h-[800px] relative`}>
//                 <div className='w-[100%] flex justify-start p-[7px] top-0 absolute z-10'>
//                   <div onClick={closeModal} className='bg-white cursor-pointer rounded-full p-[2px]'>
//                     <ClearIcon className='text-black' />
//                   </div>
//                 </div>
//                 {filePreview ? (
//                   filePreview.type === 'application/pdf' || isPDF(filePreview.data) ? (
//                     <iframe
//                       src={`data:application/pdf;base64,${filePreview.data}`}
//                       style={{ width: '100%', height: '500px' }}
//                       title="PDF Preview"
//                     />
//                   ) : (
//                     <img
//                       className='object-cover bg-fixed max-w-full max-h-full'
//                       src={`data:${filePreview.type};base64,${filePreview.data}`}
//                       alt="Document preview"
//                     />
//                   )
//                 ) : (
//                   <p>No file selected</p>
//                 )}
//               </div>
//             </ModalComp>
//           </>
//           :
//           <>
//             <ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
//             <p className='text-[black] text-base mb-3 font-semibold mt-3'>
//               Legal, financial, policy and other documents may be stored voluntarily by the organisation in its profile. These could be made available with the organisation's consent to subscribed users on specific request, subject to terms & conditions.  For details, <Link to="/contact" className='text-blue-600' > contact us.</Link>
//             </p>
//           </>
//         }
//       </div>
//     </>
//   )
// }
